module.exports = __webpack_public_path__ + "static/media/preview.45a8c2b3.svg";